import { observer } from 'mobx-react';
import ParticipantStore from '../../../../../../ParticipantStore';
import Loader from '../../../../../Loader';
import LicenseAllocationsStore from '.././Store';
import { Loading, LoadingError, Ready, Submitting, SubmittingError } from '.././Types';
import LoadingErrorView from './LoadingErrorView';
import ReadyView from './ReadyView';
import SubmittingErrorView from './SubmittingErrorView';

interface Props {
  state: Loading | LoadingError | Ready | Submitting | SubmittingError;
  licenseAllocationsStore: LicenseAllocationsStore;
  participantStore: ParticipantStore;
}

function Body({ state, licenseAllocationsStore, participantStore }: Props) {
  switch (state.kind) {
    case 'loading':
      return <Loader className="h-full" />;
    case 'loading-error':
      return <LoadingErrorView state={state} />;
    case 'ready':
      return (
        <ReadyView
          state={state}
          licenseAllocationsStore={licenseAllocationsStore}
          participantStore={participantStore}
        />
      );
    case 'submitting':
      return <Loader className="h-full" />;
    case 'submitting-error':
      return <SubmittingErrorView state={state} />;
  }
}

export default observer(Body);
